import {Injectable} from '@angular/core';
import {NormalFilterItem} from "../interface/normal-filter-item";
import {ColorFilterItem} from "../interface/color-filter-item";
import {RangeFilterItem} from "../interface/range-filter-item";
import {SubCategoryControls} from "../interface/sub-category-controls";

@Injectable({
    providedIn: 'root'
})
export class FilteredValueFromKeyService {

    constructor() {
    }


    public getValuesFromNormalFilterControls(
        normalFilterItems: NormalFilterItem[]
    ): string[] {

        const values: string[] = [];

        normalFilterItems = normalFilterItems.filter((normalFilterItem: NormalFilterItem) => normalFilterItem.activated);
        normalFilterItems.forEach((normalFilterItem: NormalFilterItem) => values.push(normalFilterItem.name));

        return values;
    }

    public getValuesFromColorFilterControls(
        colorFilterItems: ColorFilterItem[]
    ): string[] {

        const values: string[] = [];
        colorFilterItems.forEach((colorFilterItem: ColorFilterItem) => {

            if (colorFilterItem.activated) {
                values.push(colorFilterItem.name)
            }
        })

        return values;
    }

    public getValuesFromRangeFilterControls(value: RangeFilterItem): string[] {
        let values: string[] = [];

        if (value.value1 || value.defaultMax === value.value2) {
            values = [];
        }
        if (value.defaultMin < value.value1 || value.defaultMax > value.value2) {
            values = ['min-' + value.value1, 'max-' + value.value2];
        }

        return values;

    }

    public getValuesFromNestedFilterControls(value: SubCategoryControls[]): string[] {
        let values: string[] = [];

        value.forEach((controls) => {

            if (controls.activated) {
                values.push(controls.name)
            }
        })

        return values;

    }

    public getValuesFromSingleFilterControls(value: boolean): string[] {

        let values: string[] = [];
        if(value){
            values = ['true']
        }

        return values;

    }
}
